import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input, Label } from "@/components/ui/input";
import { ApiClient, describeError } from "@/data/api";
import { savePairing } from "@/data/session";

/** Production fallback when no Electron bridge or dev session is available. */
export function PairingScreen({ onPaired, reason }: { onPaired: () => void; reason?: string }) {
  const [apiUrl, setApiUrl] = useState("http://127.0.0.1:4319");
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(reason ?? null);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      const client = new ApiClient({ apiUrl: apiUrl.replace(/\/+$/, ""), token: token.trim(), source: "paired" });
      await client.bootstrap();
      savePairing(apiUrl, token);
      setToken("");
      onPaired();
    } catch (e) {
      setError(describeError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex h-full items-center justify-center bg-background p-6">
      <form
        className="w-full max-w-[380px]"
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <h1 className="mb-1 font-display text-[26px] font-semibold tracking-[-0.015em]">Desk</h1>
        <p className="mb-6 text-[14px] text-muted-foreground">
          Connect to your Desk service. The owner token is in <code className="text-[12.5px]">credentials.json</code> in the Desk data folder.
        </p>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="pair-url">Service URL</Label>
            <Input id="pair-url" value={apiUrl} onChange={(e) => setApiUrl(e.target.value)} autoComplete="off" spellCheck={false} />
          </div>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="pair-token">Owner token</Label>
            <Input id="pair-token" type="password" value={token} onChange={(e) => setToken(e.target.value)} autoComplete="off" spellCheck={false} />
          </div>
          {error && (
            <p role="alert" className="rounded-md bg-urgent-soft px-3 py-2 text-[13px]">
              {error}
            </p>
          )}
          <Button type="submit" variant="default" size="lg" disabled={busy || !token.trim() || !apiUrl.trim()}>
            {busy ? "Connecting…" : "Connect"}
          </Button>
        </div>
      </form>
    </div>
  );
}
